import {IAIReviewDocErrorPanelResponse} from '../../../../../api/types/aiReview.type';
import {generateRandomNumber} from '../../../../../utils/utils';

// Mock data in case of API failure
const errorMessages = [
  'File not found',
  'Access denied',
  'Invalid document format',
  'Timeout while processing',
  'Missing required fields',
  'Parsing failed',
  'Upload failed',
  'Checksum mismatch',
  'Permission error',
  'Unknown server error',
];

export const getDocErrorPanelMockResponse: IAIReviewDocErrorPanelResponse = {
  items: Array.from({length: 30}, (_, i) => ({
    docId: `ID${String(i + 1).padStart(5, '0')}`,
    errorMessage:
      errorMessages[Math.floor(generateRandomNumber() * errorMessages.length)],
  })),
  total: 30,
};
